import { Anchor } from "@mantine/core"
import Link from "next/link"
import { BuildAdminLink } from "@/utils"

interface IProps {
  resource: string
  children: React.ReactNode
  id?: string
  type?: string
  filter?: { [key: string]: any }
  sort?: string
  order?: string
}

export function AdminLink({ resource, children, ...props }: IProps) {
  const url = BuildAdminLink(resource, props)
  return (
    <Anchor href={url} target="_blank" component={Link} fw={600} c="cyan">
      {children}
    </Anchor>
  )
}
